// src/pages/payment/SuccessPage.jsx
import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { C, FONT, primaryButtonSx } from "./accountStyles";
import PaymentResult from "./components/PaymentResult";



const bodySx = { fontFamily: FONT, color: C.text, fontSize: "1.05rem", lineHeight: 1.6, mb: 2 };

export default function SuccessPage() {
  return (
    <PaymentResult
      id="payment-success-title"
      closeTo="/home"
      title="Thank you for your payment!"
      icon={<CheckCircleOutlineIcon aria-hidden="true" sx={{ fontSize: 64, color: C.success, mb: 2 }} />}
      action={
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button component={Link} to="/home" variant="contained" disableElevation sx={{ ...primaryButtonSx, width: { xs: "100%", sm: "auto" } }}>
            Go Back to Home
          </Button>
        </Stack>
      }
    >
      <Typography sx={bodySx}>
        Your payment is currently being <strong>processed</strong>.
      </Typography>
      <Typography sx={bodySx}>
        Once the transaction is complete, you will receive a
        <strong> confirmation email</strong> with your official receipt.
      </Typography>
      <Typography sx={{ fontFamily: FONT, color: C.secondary, fontSize: "0.95rem", fontStyle: "italic", lineHeight: 1.6 }}>
        If you do not receive the email within a few minutes, please check
        your spam folder or contact our support team.
      </Typography>
    </PaymentResult>
  );
}
